import { useCallback, useEffect, useState } from "react";
import { Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate, shiftName, STATUS_STYLE } from "@/components/staff/attendance/utils";

const RequestRow = ({ r, config, onDone }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const decide = async (decision) => {
    setBusy(true);
    try { await api.post(`/admin/shift-requests/${r.id}/${decision}`, { note }); toast.success(decision === "approve" ? "Tukar shift disetujui, jadwal diperbarui" : "Pengajuan ditolak"); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="py-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`shift-request-${r.id}`}>
      <div className="flex-1 min-w-[220px]">
        <div className="font-semibold">{r.name} <span className="font-normal text-muted2">· {fmtDate(r.date)}</span></div>
        <div>{shiftName(config, r.from_shift)} → <b>{shiftName(config, r.to_shift)}</b>{r.partner_name && <span className="text-muted2"> · tukar dengan {r.partner_name} ({shiftName(config, r.partner_from_shift)} → {shiftName(config, r.from_shift)})</span>}</div>
        {r.reason && <div className="text-xs text-muted2">Alasan: {r.reason}</div>}
        {r.admin_note && <div className="text-xs text-muted2">Catatan admin: {r.admin_note}</div>}
      </div>
      {r.status === "menunggu" ? (
        <div className="flex flex-wrap items-center gap-2">
          <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={200} placeholder="Catatan (opsional)" className="px-3 py-1.5 rounded-lg border border-sage-200 bg-paper text-xs w-40" data-testid={`shift-request-note-${r.id}`} />
          <button disabled={busy} onClick={() => decide("approve")} className="btn-forest px-3 py-1.5 text-xs flex items-center gap-1" data-testid={`shift-request-approve-${r.id}`}><Check className="w-3.5 h-3.5" /> Setujui</button>
          <button disabled={busy} onClick={() => decide("reject")} className="px-3 py-1.5 rounded-full bg-red-50 text-red-700 text-xs font-semibold flex items-center gap-1" data-testid={`shift-request-reject-${r.id}`}><X className="w-3.5 h-3.5" /> Tolak</button>
        </div>
      ) : <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${STATUS_STYLE[r.status]}`}>{r.status}</span>}
    </div>
  );
};

export const ShiftRequestsAdmin = ({ config, onChanged }) => {
  const [list, setList] = useState(null);
  const load = useCallback(() => { api.get("/admin/shift-requests").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  useEffect(() => { load(); }, [load]);
  if (!list) return <div className="card-paper p-5 mt-8 text-sm text-muted2" data-testid="shift-requests-loading">Memuat pengajuan tukar shift...</div>;
  const pending = list.filter((r) => r.status === "menunggu");
  const done = list.filter((r) => r.status !== "menunggu").slice(0, 10);
  return (
    <div className="card-paper p-5 mt-8" data-testid="shift-requests-admin">
      <h3 className="font-serif font-semibold text-xl">Pengajuan tukar shift <span className="text-sm font-sans font-semibold px-2 py-0.5 rounded-full bg-amber-50 text-amber-800 ml-1 whitespace-nowrap inline-block align-middle" data-testid="shift-requests-pending-count">{pending.length} menunggu</span></h3>
      <div className="divide-y divide-sage-200 mt-2">
        {pending.length === 0 && <p className="text-sm text-muted2 py-3">Tidak ada pengajuan yang menunggu.</p>}
        {pending.map((r) => <RequestRow key={r.id} r={r} config={config} onDone={() => { load(); onChanged?.(); }} />)}
      </div>
      {done.length > 0 && (
        <>
          <div className="text-xs font-semibold text-muted2 mt-4">Riwayat terakhir</div>
          <div className="divide-y divide-sage-200">{done.map((r) => <RequestRow key={r.id} r={r} config={config} onDone={load} />)}</div>
        </>
      )}
    </div>
  );
};
